/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetYoutubeCategoriesQueryResponse, GetYoutubeCategoriesPathParams } from "../models/GetYoutubeCategories";

export function getGetYoutubeCategoriesUrl(station: GetYoutubeCategoriesPathParams["station"]) {
  const res = { method: 'GET', url: `/youtube/${station}/categories` as const }
  return res
}

/**
 * @description Returns available YouTube video categories based on the station country code
 * @summary Get YouTube video categories for a station
 * {@link /youtube/:station/categories}
 */
export async function getYoutubeCategories(station: GetYoutubeCategoriesPathParams["station"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetYoutubeCategoriesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetYoutubeCategoriesUrl(station).url.toString(), ... requestConfig })
  return res.data
}